import { paramValuesAreSimilar } from './util';
import TrackingScope from './TrackingScope';
export class Loader {
    onLoad;
    onFree;
    results = [];
    promise;
    scope;
    constructor(onLoad, onFree) {
        this.onLoad = onLoad;
        this.onFree = onFree;
    }
    needsLoad(params, attribs) {
        if (!this.scope)
            return true;
        if ([...this.scope.usedPathParams].some(p => !paramValuesAreSimilar(this.scope.params.path[p], params.path[p])))
            return true;
        if ([...this.scope.usedQueryParams].some(p => !paramValuesAreSimilar(this.scope.params.query[p], params.query[p])))
            return true;
        if ([...this.scope.usedAttribs].some(a => this.scope.attribs[a] !== attribs[a]))
            return true;
        if ([...this.scope.usedLoaders.entries()].some(([l, r]) => l.needsLoad(params, attribs) || l.promise !== r))
            return true;
        return false;
    }
    getResult(scope) {
        if (!(scope instanceof TrackingScope))
            throw new Error('invalid scope');
        if (this.needsLoad(scope.params, scope.attribs)) {
            this.promise = this.doLoad(scope);
            this.promise.catch(() => {
                // avoids incorrect reporting of uncaught errors in Chrome
            });
        }
        scope.addLoader(this, this.promise);
        return this.promise;
    }
    async doLoad(scope) {
        this.scope = new TrackingScope(scope.params, scope.attribs);
        const result = await this.onLoad(this.scope, this.results[0]);
        this.results.unshift(result);
        return result;
    }
    collectAffectedLoaders(set) {
        set.add(this);
        this.scope?.usedLoaders.forEach((p, l) => l.collectAffectedLoaders(set));
    }
    clean() {
        this.freeResults(1);
    }
    reset() {
        this.freeResults(0);
        this.promise = undefined;
        this.scope = undefined;
    }
    freeResults(offset = 0) {
        for (let i = offset; i < this.results.length; i++) {
            this.onFree?.(this.results[i]);
        }
        this.results.splice(offset);
    }
}
